export default __webpack_public_path__ + "static/media/BMWGroupCondensed-Bold.6a5a8115.woff";